import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_coldFlu_redFlagSymptoms',
    label: 'Are you experiencing any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Gasping for air', key: 'gasping_for_air' },
        { value: 'Lips that are gray or blue', key: 'gray_blue_lips' },
        {
          value:
            'Chest pain or pressure not related to coughing or deep breathing',
          key: 'chest_pain_pressure'
        },
        { value: 'Coughing up blood', key: 'coughing_up_blood' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_fever',
    label: 'Do you currently have a fever?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No fever', key: 'no_fever' },
        { value: 'Mild fever (100.4–102°F)', key: 'mild_fever' },
        { value: 'High fever (≥102°F)', key: 'high_fever' },
        { value: "I don't know", key: 'unknown' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_symptoms',
    label: 'Which of these symptoms are you experiencing?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Dry cough', key: 'dry_cough' },
        { value: 'Wet or productive cough', key: 'wet_cough' },
        { value: 'Shortness of breath', key: 'shortness_of_breath' },
        { value: 'Nasal congestion or runny nose', key: 'nasal_congestion' },
        { value: 'Sore throat', key: 'sore_throat' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_additionalSymptoms',
    label: 'Are you experiencing any of these additional symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Chills', key: 'chills' },
        { value: 'Significant muscle or body aches', key: 'muscle_body_aches' },
        { value: 'Severe fatigue or exhaustion', key: 'severe_fatigue' },
        { value: 'Headache', key: 'headache' },
        { value: 'Upset stomach or diarrhea', key: 'upset_stomach_diarrhea' },
        { value: 'Loss of taste or smell', key: 'loss_taste_smell' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_symptomOnset',
    label: 'How did your symptoms start?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Suddenly (all at once)', key: 'suddenly' },
        { value: 'Gradually (it built up over a day or two)', key: 'gradually' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_covidTestPast10Days',
    label: 'In the past 10 days, have you:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Tested positive for COVID-19', key: 'positive' },
        { value: 'Tested negative for COVID-19', key: 'negative' },
        { value: 'Not been tested', key: 'not_tested' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_closeContact',
    label: 'Have you been in close contact with someone diagnosed with:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'COVID-19', key: 'covid19' },
        { value: 'Influenza', key: 'influenza' },
        { value: 'Not sure', key: 'not_sure' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_coldFlu_additionalComments'
    }
  },
  {
    field: 'zalud_coldFlu_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_coldFlu_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludColdFluQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
